import { LineListTemplate } from '../../entity/model/line-list-template';
import { RequestBody } from '../../entity/core/request-body';
import LineListTemplateAgent from '../agent/line-list-template-agent';

export default class LineListTemplateStore {
  lineListTemplateAgent: LineListTemplateAgent;
  private templates: LineListTemplate[] = [];

  constructor(lineListTemplateAgent: LineListTemplateAgent) {
    this.lineListTemplateAgent = lineListTemplateAgent;
  }

  createLineListTemplate = async (organizationId: string, requestBody: RequestBody): Promise<LineListTemplate | string> => {
    try {
      return await this.lineListTemplateAgent.createLineListTemplate(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while creating line list template', error);
      return 'Error occurred while creating line list template !!';
    }
  }

  getLineListTemplates = async (organizationId: string): Promise<LineListTemplate[] | string> => {
    try {
      const result = await this.lineListTemplateAgent.getLineListTemplates(organizationId);
      if (typeof result === 'string') {
        return result;
      }
      this.templates = result;
      return result;
    } catch (error: any) {
      console.error('Error occurred while getting line list templates', error);
      return 'Error occurred while getting line list templates !!';
    }
  }

  filterTemplates = (searchQuery: string): LineListTemplate[] => {
    if (!searchQuery.trim()) {
      return this.templates;
    }
        
    const query = searchQuery.toLowerCase();
    return this.templates.filter(template => 
      template.templateName?.toLowerCase().includes(query) ?? false
    );
  }
} 